// Copyright ID Business Solutions Ltd. 2023

import styled from 'styled-components';

export const ImportButtonWrapper = styled.div`
  margin-left: 10px;
`;
